import { Link } from '~/elements/Link'
import { Skeleton } from '~/elements/Skeleton'
import { useCurrentWorkspacePlan } from '~/features/billing/hooks/useBillingHooks'
import { formatDate } from '~/features/billing/utils'
import { cn } from '~/lib/utils'

export function CurrentSubscriptionInfo({ className, ...props }: TPolymorphicComponentProps<'div'>) {
  const { name, isPaid, state, loading } = useCurrentWorkspacePlan()
  const cancelAt = state?.scheduledChange?.action === 'cancel' ? state.scheduledChange.effectiveAt : null

  return (
    <div className={cn('flex w-full flex-col items-end text-sm', className)} {...props}>
      <Skeleton enabled={loading}>
        <span className="text-semibold">{name}</span>
      </Skeleton>
      <Skeleton enabled={loading}>
        {isPaid && cancelAt ?
          <span className="flex gap-1 text-xs">
            Ends on
            <Link as="span" size="xsmall">
              {formatDate(cancelAt)}
            </Link>
          </span>
        : isPaid && state?.status === 'past_due' ?
          <span className="text-xs text-danger">Payment failed</span>
        : isPaid ?
          <span className="text-xs text-content3">Active subscription</span>
        : <Link as="span" size="xsmall">
            Upgrade
          </Link>
        }
      </Skeleton>
    </div>
  )
}
